import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

/**
 * Whether ContentLayout shows the right sidebar next to the content.
 * Keep the breakpoint in sync with `ContentLayout.vue` and the `.ShowWithSidebar` / `.HideWithSidebar` aliases.
 * @returns Reactive flag, true from `lg` up
 */
export function useIsSidebarVisible() {
  return useBreakpoints(breakpointsTailwind).greaterOrEqual('lg')
}
